import {LogoSuite, useTheme} from '@primer/react-brand/esm'
import {clsx} from 'clsx'

import {LogoSuiteMap} from '@github-ui/swp-core/components/contentful/ContentfulLogoSuite'

import Styles from './LogoMarquee.module.css'

export interface LogoMarqueeProps {
  a11y: {
    title: string
  }
  logos: string[]
}

export const defaultProps: Partial<LogoMarqueeProps> = {}

export const LogoMarquee = (props: LogoMarqueeProps) => {
  const initializedProps: LogoMarqueeProps = {...defaultProps, ...props}
  const {a11y, logos} = initializedProps
  const {colorMode} = useTheme()

  return (
    <LogoSuite
      className={clsx(Styles.LogoMarquee, colorMode === 'dark' && Styles['LogoMarquee--dark'])}
      hasDivider={false}
    >
      <LogoSuite.Heading as="h2" visuallyHidden>
        {a11y.title}
      </LogoSuite.Heading>
      <LogoSuite.Logobar marquee marqueeSpeed="slow" variant="muted">
        {logos.map(name => {
          const Logo = LogoSuiteMap[name]
          if (!Logo) throw new Error(`Unknown logo: ${name}`)
          return <Logo key={name} />
        })}
      </LogoSuite.Logobar>
    </LogoSuite>
  )
}
